import {
  FormHelperText,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useAddress } from "components/request-document/components/Address";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function PersonalIncomePensioner({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const sourceIncoms = get(masterData, "sourcesOfincomeConfig", []);

  useEffect(() => {
    const n1 =
      formik.values.document.NolessDateUSD !== ""
        ? parseFloat(formik.values.document.NolessDateUSD)
        : 0;
    const n2 =
      formik.values.document.NolessAmountUSD !== ""
        ? parseFloat(formik.values.document.NolessAmountUSD)
        : 0;
    const sum = n1 + n2;
    formik.setFieldValue("document.TotalIncomeNoless", sum);
    console.log(sum);
  }, [
    formik.values.document.NolessDateUSD,
    formik.values.document.NolessAmountUSD,
  ]);

  useEffect(() => {
    const n1 =
      formik.values.document.MorethanDateUSD !== ""
        ? parseFloat(formik.values.document.MorethanDateUSD)
        : 0;
    const n2 =
      formik.values.document.MorethanAmountUSD !== ""
        ? parseFloat(formik.values.document.MorethanAmountUSD)
        : 0;
    const sum = n1 + n2;
    formik.setFieldValue("document.TotalMorethanNoless", sum);
  }, [
    formik.values.document.MorethanDateUSD,
    formik.values.document.MorethanAmountUSD,
  ]);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography style={{ fontWeight: "bold" }}>
                Average personal income per year{" "}
              </Typography>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.IncomeNoless"
                    checked={formik.values.document.IncomeNoless === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.IncomeNoless",
                        formik.values.document.IncomeNoless === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={
                  <Typography style={{ fontWeight: "bold" }}>
                    {` Personal pension income and/or fixed income no less than 80,000 USD/year `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.IncomeNoless === "true" ? (
        <>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Income in current year</InputLabel>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Amount (USD)</InputLabel>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>
                    (1) Total  income (as of the submission date)
                  </InputLabel>
                  <FormGroup row>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start"
                      views={["year", "month", "date"]}
                      name={`document.NolessDate`}
                      value={
                        get(formik.values, `document.NolessDate`, null) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.NolessDate`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(`document.NolessDate`, formik)}
                      helperText={getErrorMessage(
                        `document.NolessDate`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End"
                      views={["year", "month", "date"]}
                      name={`document.NolessDateEnd`}
                      value={
                        get(formik.values, `document.NolessDateEnd`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.NolessDateEnd`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(`document.NolessDateEnd`, formik)}
                      helperText={getErrorMessage(
                        `document.NolessDateEnd`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </FormGroup>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.NolessDateUSD"
                    value={formik.values.document.NolessDateUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.NolessDateUSDr", formik)}
                    helperText={getErrorMessage(
                      "document.NolessDateUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>(2) Other Sources of fixed income </InputLabel>
                  <FormGroup row>
                    {sourceIncoms.map((x) => (
                      <>
                        {x.sourcesOfincomeID !== "O" ? (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.NolesssourcesOfincomeID"
                                checked={formik.values.document.NolesssourcesOfincomeID.split(
                                  ","
                                ).some((xs) => xs === x.sourcesOfincomeID)}
                                onClick={() => {
                                  const arr =
                                    formik.values.document.NolesssourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                        (xs) => xs !== x.sourcesOfincomeID
                                      )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.NolesssourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                        ) : null}
                      </>
                    ))}
                  </FormGroup>
                  {sourceIncoms.map((x) => (
                    <>
                      {x.sourcesOfincomeID === "O" ? (
                        <>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.NolesssourcesOfincomeID"
                                checked={
                                  formik.values.document.NolesssourcesOfincomeID.split(
                                    ","
                                  ).some((xs) => xs === x.sourcesOfincomeID)
                                  // formik.values.document.sourcesOfincomeID ===
                                  // x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  const arr =
                                    formik.values.document.NolesssourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                        (xs) => xs !== x.sourcesOfincomeID
                                      )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.NolesssourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                          <TextField
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="document.NolesssourcesOfincomeOther"
                            value={
                              formik.values.document.NolesssourcesOfincomeOther
                            }
                          />
                        </>
                      ) : null}
                    </>
                  ))}
                  <FormHelperText
                    error={isError("document.NolesssourcesOfincomeID", formik)}
                  >
                    {getErrorMessage(
                      "document.NolesssourcesOfincomeID",
                      formik
                    )}
                  </FormHelperText>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.NolessAmountUSD"
                    value={formik.values.document.NolessAmountUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.NolessAmountUSD", formik)}
                    helperText={getErrorMessage(
                      "document.NolessAmountUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={7}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Total 1+2</InputLabel>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.TotalIncomeNoless"
                    value={formik.values.document.TotalIncomeNoless}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.TotalIncomeNoless", formik)}
                    helperText={getErrorMessage(
                      "document.TotalIncomeNoless",
                      formik
                    )}
                    inputProps={{ readOnly: true }}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}

      {/* End Section 1 */}

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.IncomeMorethan"
                    checked={formik.values.document.IncomeMorethan === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.IncomeMorethan",
                        formik.values.document.IncomeMorethan === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={
                  <Typography style={{ fontWeight: "bold" }}>
                    {` Personal pension income and/or fixed income >= 40,000
                    USD/year but below 80,000 USD/year`}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.IncomeMorethan === "true" ? (
        <>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Income in current year</InputLabel>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Amount (USD)</InputLabel>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>
                    (1) Total  income (as of the submission date)
                  </InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Start"
                    views={["year", "month", "date"]}
                    name={`document.MorethanDate`}
                    value={
                      get(formik.values, `document.MorethanDate`, null) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`document.MorethanDate`, formik)}
                    helperText={getErrorMessage(
                      `document.MorethanDate`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="End"
                    views={["year", "month", "date"]}
                    name={`document.MorethanDateEnd`}
                    value={
                      get(formik.values, `document.MorethanDateEnd`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanDateEnd`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`document.MorethanDateEnd`, formik)}
                    helperText={getErrorMessage(
                      `document.MorethanDateEnd`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.MorethanDateUSD"
                    value={formik.values.document.MorethanDateUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.MorethanDateUSD", formik)}
                    helperText={getErrorMessage(
                      "document.MorethanDateUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>(2) Other Sources of fixed income </InputLabel>
                  <FormGroup row>
                    {sourceIncoms.map((x) => (
                      <>
                        {x.sourcesOfincomeID !== "O" ? (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.MorethanWPsourcesOfincomeID"
                                checked={formik.values.document.MorethanWPsourcesOfincomeID.split(
                                  ","
                                ).some((xs) => xs === x.sourcesOfincomeID)}
                                onClick={() => {
                                  const arr =
                                    formik.values.document.MorethanWPsourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                        (xs) => xs !== x.sourcesOfincomeID
                                      )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.MorethanWPsourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                        ) : null}
                      </>
                    ))}
                  </FormGroup>
                  {sourceIncoms.map((x) => (
                    <>
                      {x.sourcesOfincomeID === "O" ? (
                        <>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.MorethanWPsourcesOfincomeID"
                                checked={
                                  formik.values.document.MorethanWPsourcesOfincomeID.split(
                                    ","
                                  ).some((xs) => xs === x.sourcesOfincomeID)
                                  // formik.values.document.sourcesOfincomeID ===
                                  // x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  const arr =
                                    formik.values.document.MorethanWPsourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                        (xs) => xs !== x.sourcesOfincomeID
                                      )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.MorethanWPsourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                          <TextField
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="document.MorethanWPsourcesOfincomeOther"
                            value={
                              formik.values.document
                                .MorethanWPsourcesOfincomeOther
                            }
                          />
                        </>
                      ) : null}
                    </>
                  ))}
                  <FormHelperText
                    error={isError(
                      "document.MorethanWPsourcesOfincomeID",
                      formik
                    )}
                  >
                    {getErrorMessage(
                      "document.MorethanWPsourcesOfincomeID",
                      formik
                    )}
                  </FormHelperText>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.MorethanAmountUSD"
                    value={formik.values.document.MorethanAmountUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.MorethanAmountUSD", formik)}
                    helperText={getErrorMessage(
                      "document.MorethanAmountUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={7}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Total 1+2</InputLabel>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.TotalMorethanNoless"
                    value={formik.values.document.TotalMorethanNoless}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.TotalMorethanNoless", formik)}
                    helperText={getErrorMessage(
                      "document.TotalMorethanNoless",
                      formik
                    )}
                    inputProps={{ readOnly: true }}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography style={{ fontWeight: "bold" }}>
                {` The applicant must have one of the followings investments in Thailand`}
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PersonalGovernmentBond"
                    checked={
                      formik.values.document.PersonalGovernmentBond === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PersonalGovernmentBond",
                        formik.values.document.PersonalGovernmentBond === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={
                  <Typography>
                    {` Thai government bonds issued by Ministry of Finance  `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PersonalRealEstate"
                    checked={
                      formik.values.document.PersonalRealEstate === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PersonalRealEstate",
                        formik.values.document.PersonalRealEstate === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={<Typography>{` Real estate    `}</Typography>}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PersonalDirectInvestment"
                    checked={
                      formik.values.document.PersonalDirectInvestment === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PersonalDirectInvestment",
                        formik.values.document.PersonalDirectInvestment ===
                          "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={
                  <Typography>
                    {` Direct investment as an individual investor in company   `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
